// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--XK0PC","siteContainer":"Layout-module--site-container--ncU1f"};